module.exports = __webpack_public_path__ + "img/devils.12d4978e.svg";